export default __webpack_public_path__ + "static/au-map-6b09cfba2f61bf5c4fe600306c962117.png";